exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.new-ticket-tab-content {\r\n  text-align: center;\r\n  padding: 10vh 0;\r\n  font-size: 3vw;\r\n  color: #e8e8e8;\n}\n.el-dialog__header {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    padding-top: 20px;\n}\n.new_ticket_tabs .el-tabs__header {\r\n  border-bottom-width:  0;\n}\n.new_ticket_tabs  .el-tabs__header {\r\n  margin:0;\n}\n.new_ticket_tabs .el-tabs__nav {\r\n  margin-left: 90px;\n}\n.new_ticket_tabs .el-tabs__item {\r\n  font-size:15px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63f319a1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/NewTicketDialog.vue
// module id = 775
// module chunks = 75